export default __webpack_public_path__ + "static/sizing-30a1a99f85244895e0e974a3eaf3fe88.png";